// extracted by mini-css-extract-plugin
module.exports = {"title":"RepositionHeader_title__2ROjh","settings_icon":"RepositionHeader_settings_icon__3aEcP","close_icon":"RepositionHeader_close_icon__1RIi_"};